import { List, Table, Text } from '@mantine/core';

import { AnnualReportIsiOverview } from '@/module/AnnualReport/model/AnnualReportTypes';

import { Content } from '@/core/components';

interface IsiOverviewBoxProps {
  title: string;
  overview: AnnualReportIsiOverview;
}

export function IsiOverviewBox({ overview, title }: IsiOverviewBoxProps) {
  const {
    totalImpactFactor,
    averageImpactFactor,
    maxImpactFactor,
    minImpactFactor,
    totalIsiCount,
    topJournals,
    q1Count,
    q2Count,
    q3Count,
    q4Count,
  } = overview;

  return (
    <Content
      h="100%"
      type="full"
    >
      <Text fw="500">{title}</Text>
      <Table variant="vertical">
        <Table.Tbody>
          <Table.Tr>
            <Table.Th w={220}>Total publicații</Table.Th>
            <Table.Td>{totalIsiCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Total factor de impact</Table.Th>
            <Table.Td>{totalImpactFactor}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Factor de impact mediu</Table.Th>
            <Table.Td>{averageImpactFactor}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Factor de impact minim</Table.Th>
            <Table.Td>{minImpactFactor}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Factor de impact maxim</Table.Th>
            <Table.Td>{maxImpactFactor}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Nr. Q1</Table.Th>
            <Table.Td>{q1Count}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Nr. Q2</Table.Th>
            <Table.Td>{q2Count}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Nr. Q3 / Q4</Table.Th>
            <Table.Td>
              {q3Count} / {q4Count}
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>

      {topJournals.length > 0 && (
        <>
          <Text fw="500">Top 5 al revistelor în funcție de valoarea FI</Text>
          <List>
            {topJournals.map((j, key) => (
              // eslint-disable-next-line react/no-array-index-key
              <List.Item key={key}>
                <Text size="sm">
                  FI {j.impactFactor} {j.journalTitle}
                </Text>
              </List.Item>
            ))}
          </List>
        </>
      )}
    </Content>
  );
}
